import styled from "styled-components";

export const InputGroup = styled.div`
  margin-bottom: 15px;
  text-align: left;
  font-family: gilroy;
  label {
        margin-bottom: 0.5rem;
        display: inline-block ;
        color: gray;
        font-size: 19px
    }`
